module.exports = __webpack_public_path__ + "static/media/twitter-icon.b871c15a.svg";